import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AppType } from "src/types/apps";

const useGetApp = () => {
	const queryClient = useQueryClient();
	const apps = queryClient.getQueryData<AppType[]>(["apps"]) ?? [];
	const { data: appSelected } = useQuery<string>({
		queryKey: ["apps", "selected"],
		initialData: ""
	});

	return apps.find((i) => i.id === appSelected);
};

export default useGetApp;
